<template>
  <div class="eoev-app-conditional-date">
    <span
      v-if="currentSortField === 'moment' && showDate"
      :style="{ color: textColor }"
      >{{ niceDate }} &mdash;</span
    >
    <span v-else-if="showLetter" :style="{ color: textColor }"
      >{{ showLetter }} &mdash;</span
    >
  </div>
</template>

<script>
import niceDate from "@/lib/nice-date";
import { getShortTitle } from "@/lib/get-short-title";

function getFirstLetter(text) {
  return text && text.substring(0, 1).toUpperCase();
}

export default {
  name: "eo-conditional-header",
  props: {
    idx: Number,
    events: Array,
    currentSorting: {
      type: String,
      required: true
    }
  },
  computed: {
    currentSortField() {
      return (this.currentSorting && this.currentSorting.split(":")[0]) || "";
    },
    showDate() {
      // show first date in any case
      if (this.idx === 0) return true;

      // show date, if different from last one
      if (this.events[this.idx].moment && this.events[this.idx - 1].moment) {
        // compare dates only
        const from1 = this.events[this.idx - 1].moment.from
          .toString()
          .substr(0, 10);
        const from2 = this.events[this.idx].moment.from
          .toString()
          .substr(0, 10);

        if (from1 !== from2) return true;
      }

      // all other cases: hide date
      return false;
    },
    niceDate() {
      return niceDate(
        this.events[this.idx].moment.from,
        this.$vuetify.lang.current,
        false,
        true
      );
    },
    showLetter() {
      // determine field
      const sorting =
        (this.currentSorting && this.currentSorting.split(":")[0]) || "";

      // noinspection JSUnreachableSwitchBranches
      switch (sorting) {
        case "title_asc":
          const thisTitleLetter = getFirstLetter(getShortTitle(this.events[this.idx])); // eslint-disable-line

          // show first entry in any case
          if (this.idx === 0) return thisTitleLetter;

          const lastTitleLetter = getFirstLetter(getShortTitle(this.events[this.idx - 1])); // eslint-disable-line

          return thisTitleLetter !== lastTitleLetter ? thisTitleLetter : "";
        case "location":
          const thisLocationLetter = getFirstLetter(this.events[this.idx].location && this.events[this.idx].location.length && this.events[this.idx].location[0].title); // eslint-disable-line

          // show first entry in any case
          if (this.idx === 0) return thisLocationLetter;

          const lastLocationLetter = getFirstLetter(this.events[this.idx - 1].location && this.events[this.idx - 1].location.length && this.events[this.idx - 1].location[0].title); // eslint-disable-line

          return thisLocationLetter !== lastLocationLetter
            ? thisLocationLetter
            : "";
      }

      return "";
    },
    textColor() {
      return this.$vuetify.theme.currentTheme.primary;
    }
  }
};
</script>

<style lang="sass">
.eoev-app-conditional-date
  height: 2em
  font-size: 125%
  font-weight: bold
</style>
